module.exports = __webpack_public_path__ + "20250828d091945t/img/ewm2.25bff2fe.png";